<template>
    <div>
        <div style="display: flex; height: 100%;">
            <div tabindex="1" id="audit_txts" :loading="docLoading" style="height: 100%;">
                <!-- <iframe id="audit_doc" width="100%" height="100%" src="" frameborder="0"></iframe> -->
                 <VEditor ref="VEditor" :showTools="editable" style="width: 100%; height: 100%;" :editorContent="editContent" :height="editHeight" @saveEditor="editorSave"></VEditor>
            </div>
            
            <div class="right-box">
                <template v-if="editable">
                    <h3 style="text-align: left; padding: 14px 0">审核结果：</h3>
                    <!-- <i @click="dlgMzsmVisible = true" class="el-icon-warning icons" v-if="this.$root.clientType === 0">免责声明</i> -->
                </template>

                <el-tabs v-model="activeTabName" style="width: 100%; max-height: 521px; min-height: 254px;">
                    <el-tab-pane label="错别字" name="错别字">
                        <span slot="label">
                            <span>错别字</span>
                            <el-badge v-if="typoList.length > 0" :value="typoList.length" size="mini" class="item"></el-badge>
                        </span>
                    </el-tab-pane>
                    <el-tab-pane label="敏感词" name="敏感词">
                        <span slot="label">
                            <span>敏感词</span>
                            <el-badge v-if="senList.length > 0" :value="senList.length" size="mini" class="item"></el-badge>
                        </span>
                    </el-tab-pane>
                    <el-tab-pane label="禁用词" name="禁用词">
                        <span slot="label">
                            <span>禁用词</span>
                            <el-badge v-if="stopList.length > 0" :value="stopList.length" size="mini" class="item"></el-badge>
                        </span>
                    </el-tab-pane>
                    <el-tab-pane label="疑似错别字" name="疑似错别字">
                        <span slot="label">
                            <span> 疑似错别字</span>
                            <el-badge v-if="suspectList.length > 0" :value="suspectList.length" size="mini" class="item"></el-badge>
                        </span>
                    </el-tab-pane>
                    <el-tab-pane label="AI助手" name="AI助手" v-if="showdpmode">
                        <!-- <span slot="label">
                            <span style="font-weight: bold !important; color: orange; font-size: 16px;">AI助手</span>
                        </span> -->
                        <span slot="label">
                            <span>AI助手</span>
                            <el-badge v-if="dpresult.length > 0" :value="dpresult.length" size="mini" class="item"></el-badge>
                            <!-- <el-badge v-if="dpresult.length > 0" is-dot></el-badge> -->
                        </span>
                    </el-tab-pane>

                    <div class="audit-result-table">
                        <div v-if="activeTabName == 'AI助手'" style="font-size: 18px; text-indent: 2em; text-align: left; line-height: 28px; letter-spacing: 2px;">
                            <template v-for="item in dpresult">
                                <div>{{ item }}</div>
                            </template>
                        </div>
                        <table v-else style="width: 100%" class="table table-bordered table-striped text-center">
                            <thead style="background: #6fb1f7">
                                <tr>
                                    <th style="width: 20%">序号</th>
                                    <th>{{ activeTabName }}</th>
                                    <th v-if="activeTabName == '错别字' || activeTabName === '疑似错别字'">建议修改</th>
                                    <th v-if="activeTabName == '敏感词'">敏感词类型</th>
                                    <th style="width: 20%" v-if="(activeTabName == '错别字' || activeTabName == '疑似错别字') && editable === true">
                                        修改
                                        <el-checkbox class="tts" v-model="isCheckAllResult" @change="checkAllResult()"></el-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in wordResultList" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td style="cursor: pointer" @click="showSelectedWord(item)">{{ item.word }}</td>
                                    <td v-if="activeTabName == '错别字'">
                                        <span v-show="item.trueword != ''">{{ item.trueword }}</span>
                                        <span v-show="item.trueword == ' '"> 建议修改为空</span>
                                    </td>
                                    <td v-if="activeTabName === '疑似错别字'">
                                        <span>{{ item.trueword }}</span>
                                    </td>
                                    <th v-if="activeTabName == '敏感词'">{{ item.type }}</th>
                                    <th v-if="(activeTabName == '错别字' || activeTabName == '疑似错别字') && editable === true && !item.img">
                                        <template>
                                            <el-checkbox class="tts" v-model="item.checked" @change="checkItemResult(item)">
                                                <i :class="'icon' + item.number" 
                                                    style="position: absolute; right: 10px; top: 4px; color: rgb(255, 255, 255); z-index: 100; display: none;"
                                                    class="el-icon-check">
                                                </i>
                                            </el-checkbox>
                                        </template>
                                    </th>
                                </tr>
                            </tbody>

                            <div v-show="wordResultList.length <= 0" style="width: 83px; margin-left: 11vw; padding: 28px 0px">
                                <img src="../assets/wsj.png" alt="" />
                                <span>暂无数据</span>
                            </div>
                        </table>

                        <template v-if="editable">
                            <el-button v-if="activeTabName == '错别字' || activeTabName == '疑似错别字'" type="primary" @click="btnXiuGai()" plain>确认修改</el-button>
                            <el-button v-if="activeTabName == '错别字' || activeTabName == '疑似错别字'" type="success" @click="btnCheHui()">撤回</el-button>
                            <!-- v-show="shows && statuss != 1" -->
                            <!-- <el-button v-if="showExportBtn" type="warning" icon="el-icon-printer" @click="exportWord()">导出</el-button> -->
                            <!-- <el-button v-if="showExportBtn && activeTabName != 'AI助手'" 
                                type="warning" icon="el-icon-printer" @click="exportWord()">导出</el-button> -->
                            <el-dropdown @command="exportCommand">
                                <el-button v-if="showExportBtn && activeTabName != 'AI助手'" type="warning" icon="el-icon-printer" 
                                        :loading="exportResultLoading">
                                    导出
                                </el-button>

                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="html">格式页面导出</el-dropdown-item>
                                    <el-dropdown-item command="text">文本内容导出</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </div>
                </el-tabs>
            </div>
        </div>

        <!-- <div v-if="editable">
            <p v-show="auditContentLen != 0" style="position: absolute; text-align: right; color: #909399; width: 55%; bottom: 105px;">
                已输入{{ auditContentLen }}个字
            </p>
        </div> -->

        <el-dialog :visible.sync="dlgMzsmVisible" width="550px" style="text-align: left">
            <div slot="title" style="font-size: 18px" class="dialog-title">
                <i class="el-icon-warning" style="color: #ff8d00; font-size: 20px; margin-right: 6px"></i>
                <span class="title-text">免责声明</span>
                <div class="button-right">
                    <span class="title-close" @click="dlgMzsmVisible = false"></span>
                </div>
            </div>
            <div style="font-size: 16px; line-height: 25px">
                蓝太审核提供的全部审核结果均为机器审核，未经人工审核。审核结果仅供参考，无法保证结果的完全准确。北京蓝太平洋科技股份有限公司对审核结果不承担相应的法律责任。同时，也欢迎您提出宝贵建议，帮助我们不断优化审核能力。
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dlgMzsmVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import JSZipUtils from "jszip-utils"
import { saveAs } from "file-saver"
import docxtemplater from "docxtemplater"
import PizZip from "pizzip";
import VEditor from './Common/VEditor.vue'
function getFrm (frmList) {
    for(var i = 0; i < frmList.length; i++) {
        if(frmList[i].document.getElementById('audit_doc')) { return frmList[i] }
        var tmpFrm = getFrm(frmList[i].frames)
        if(tmpFrm) return tmpFrm
    }
    return null;
}
export default {
    components: { VEditor },
    props: {
        editable: { default: false },
        keepStyle: { default: false },
        showdpmode: { default: false },
        dpresult: { default: '' }
    },
    data () {
        return {
            editContent: '',
            editHeight: 550,
            typoList: [],
            suspectList: [],
            stopList: [],
            senList: [],

            docLoading: false,

            isCheckAllResult: false,    // 是否选中所有错别字结果
            num: -1, // 这个需要优化下
            dlgMzsmVisible: false,
            activeTabName: '',
            auditContentLen: 0,     // 记录审核文本的字数
            contentList: [],        // 记录文本修改情况，用于撤回
            wordResultList: [],
            tableDataTypo: [],
            tableDataSuspect: [],
            tableDataStop: [],
            tableDataSen: []
        }
    },
    computed: {
        showExportBtn () {
            // userType: 0-管理员 1-普通用户 2-高级用户 3-VIP用户 4-测试用户
            var userType = parseInt(sessionStorage.getItem('status'))
            // 除了普通用户、测试用户，其他用户都有权限
            if (userType === 1 || userType === 4) return false
            else return true
        }
    },
    watch: {
        activeTabName (val) {
            if (val === '禁用词') this.wordResultList = this.tableDataStop
            else if (val === '疑似错别字') this.wordResultList = this.tableDataSuspect
            else if (val === '敏感词') this.wordResultList = this.tableDataSen
            else if (val === '错别字') this.wordResultList = this.tableDataTypo
            else this.wordResultList = []

            console.log(val, this.wordResultList)
        }
    },
    methods: {
        editorSave (data) { this.editContent = data },
        getWordCount () { return this.$refs.VEditor.getWordCount() },
        getAuditIFrame () {
            return this.$refs.VEditor.getIFrame()
            var auditFrm = null
            if(window.top.document.getElementById('audit_doc')) auditFrm = window.top;
            else auditFrm = getFrm(window.top.frames)

            // console.log('audit_doc:', auditFrm)
            return auditFrm.document.getElementById('audit_doc').contentWindow
        },
        getIframeAuditHtml () { return this.$refs.VEditor.getHtml() },
        setIframeAuditHtml (htmlStr) {
            this.$refs.VEditor.setHtml(htmlStr)
            this.auditContentLen = this.$refs.VEditor.getWordCount()
            console.log('设置文本字数：', this.auditContentLen)
        },
        onTextPaste (e) {
            console.log('粘贴内容：', e.clipboardData)
            // console.log('按键事件：', e)
            // if (e.ctrlKey && e.keyCode === 86) {
            //     console.log('用户按下了Ctrl+V')
            //     var htmlStr = this.getIframeAuditHtml()
            //     this.auditContentLen = this.cleanAuditTxt(htmlStr).replace(/\n|\r/gi, "").length
            //     console.log('设置文本字数：', this.auditContentLen)
            // }
        },
        // 封装外部调用方法
        setAuditResult (typo_list, suspect_list, stop_list, sen_list) {
            this.contentList = [ this.getIframeAuditHtml() ]
            this.activeTabName = '错别字'
            this.typoList = typo_list
            this.suspectList = suspect_list
            this.stopList = stop_list
            this.senList = sen_list
            this.showAuditResult()
        },
        setImageResult (typo_list, suspect_list, stop_list, sen_list) {
            for (var i = 0; i < typo_list.length; i++) {
                var item = typo_list[i]
                this.typoList.push(typo_list[i])
                this.tableDataTypo.push({
                    'number': this.tableDataTypo.length + 1,
                    'trueword': item.trueword.length === 0 ? '建议修改为空' : item.trueword,
                    'word': item.word,
                    img: true
                })
            }
            for (var i = 0; i < suspect_list.length; i++) {
                var item = suspect_list[i]
                this.suspectList.push(suspect_list[i])
                this.tableDataSuspect.push({
                    'number': this.tableDataSuspect.length + 1,
                    'word': item.word,
                    'trueword': item.trueword,
                    img: true
                })
            }
            for (var i = 0; i < stop_list.length; i++) {
                var item = stop_list[i]
                this.stopList.push(stop_list[i])
                this.tableDataStop.push({
                    word: item.word,
                    number: this.tableDataStop.length + 1,
                    img: true
                })
            }
            for (var i = 0; i < sen_list.length; i++) {
                var item = sen_list[i]
                this.senList.push(sen_list[i])
                this.tableDataSen.push({
                    'word': item.word,
                    'type': item.type,
                    'number': this.tableDataSen.length + 1,
                    img: true
                })
            }
        },
        getCleanAuditTxt () {
            // 设置的文本有好多带换行符的，直接粘贴进来有的时候并不会展示为换行，替换成<br/>显示效果会更好
            var docHtml = this.getIframeAuditHtml()

            return this.getCleanTextNew(docHtml) // this.cleanAuditTxt(docHtml)
        },
        setAuditTxt (val) {
            // 设置的文本有好多带换行符的，直接粘贴进来有的时候并不会展示为换行，替换成<br/>显示效果会更好
            val = val.replace(/\\x3c/gi, '<')   // https://www.it1352.com/341980.html
            val = val.replace(/&lt;br[ \/]*&gt;/gi, '<br/>')
            val = val.replace(/<br[^>]*>/gi, '<br/>')
            val = val.replace(/\r\n/g, ' <br/>').replace(/\n/g, '<br/>').replace(/&nbsp;/gi, ' ')
            val = val.replace(/<([^<>]*)<br[^>]*>([^<>]*)>/gi, '<$1$2>')  // 过滤属性中出现的br标签
            // 处理：<div><br/></div>会处理成两个<br/>，需要特殊处理下，替换成<br/>
            val = val.replace(/<div[^>]*><br[^<>]*><\/div>/gi, '<br/>')

            // 针对从Word复制过来的文本，或者上传的文档，获取审核文本之前需要先格式化一下
            val = val.replace(/<font face[^>]*>/gi, '')
            val = val.replace(/<style>@font-face[\s\S]*?<\/style>/gi, '')
            val = val.replace(/<!--\[if\s+gte\s+mso\s+9\]>(?:(?!<!\[endif\]-->)[\s\S])*<!\[endif\]-->/gi, '')
            val = val.replace(/&nbsp;/gi, ' ')
            
            // 设置后重新读取，然后进行以下预处理，有些东西就是设置后重新读取html，就会出现，也不知道为什么
            val = (val + '').replace(/\\x3c/gi, '<')
            val = val.replace(/<!--\[if !supportLists\]-->([\s\S]*?)<!--\[endif\]-->/gi, '$1')
            val = val.replace(/<!--[\s\S]*?-->/gi, '')
            // 处理换行
            val = val.replace(/<\/p>/gi, '</p>\n').replace(/<\/div>/gi, '</div>\n')
            val = val.replace(/<br[^>]*>/gi, '<br/>').replace(/<br\/>/gi, '<br/>\n')
            val = val.replace(/(<\/h\d+>)/gi, '$1\n')
            // 都处理完之后，再最终更新到IFrame中
            console.log('设置审核文本：', val)
            // for (var i = 0; i < 30; i++) {
            //     console.log(i, val[i])
            // }
            this.$refs.VEditor.setHtml(val)
            this.auditContentLen = this.$refs.VEditor.getWordCount()

            this.typoList = []
            this.suspectList = []
            this.stopList = []
            this.senList = []
            this.isCheckAllResult = false
            this.activeTabName = '错别字'
            this.wordResultList = []
            this.tableDataTypo = []
            this.tableDataSuspect = []
            this.tableDataStop = []
            this.tableDataSen = []
            
            // console.log('设置审核文本：', val)
            // console.log('清洗后的文本：', this.cleanAuditTxt(val))
            console.log()
        },
        setAuditHtml (val) {
            val = val.replace(/<!--[\s\S]*?-->/gi, '')
            val = val.replace(/&nbsp;/gi, ' ').replace(/\n/gi, '')

            val = val.replace(/<\/p>/gi, '</p>\n').replace(/<\/div>/gi, '</div>\n')
            val = val.replace(/<br[^>]*>/gi, '<br/>').replace(/<br\/>/gi, '<br/>\n')
            val = val.replace(/(<\/h\d+>)/gi, '$1\n')

            this.setIframeAuditHtml(val)
            this.auditContentLen = this.cleanAuditTxt(val).replace(/\n|\r/gi, "").length

            this.typoList = []
            this.suspectList = []
            this.stopList = []
            this.senList = []
            this.isCheckAllResult = false
            this.activeTabName = '错别字'
            this.wordResultList = []
            this.tableDataTypo = []
            this.tableDataSuspect = []
            this.tableDataStop = []
            this.tableDataSen = []
        },
        resetAuditTxt () {
            console.log(this.contentList)
            if (this.contentList.length > 0) {
                this.setIframeAuditHtml(this.contentList[0])
                this.contentList = [ this.contentList[0] ]
            } 
            // else { this.setIframeAuditHtml('') }
        },
        // 还原到最初始状态，什么都没有，什么都是初始值
        cleanAudit () {
            console.log('清理审核结果')
            this.setIframeAuditHtml('')
            this.auditContentLen = 0
            this.contentList = []
            this.typoList = []
            this.suspectList = []
            this.stopList = []
            this.senList = []
            this.isCheckAllResult = false
            this.activeTabName = '错别字'
            this.wordResultList = []
            this.tableDataTypo = []
            this.tableDataSuspect = []
            this.tableDataStop = []
            this.tableDataSen = []
            this.dpresult = []
            console.log('清理完成')
        },
        gotoWordPos (wordid, wordPos) {
            console.log('定位：', wordid, wordPos)
            var frameWin = this.getAuditIFrame()
            console.log('定位文本所在Frame：', frameWin)
            // 先将位置滚动到最顶部，方便下面准确定位
            frameWin.scroll(0, 0)
            // 将页面滚动到词所在的位置
            var wordTop = frameWin.document.querySelectorAll('.' + wordid)[wordPos].offsetTop
            console.log('wordTop:', wordTop)
            frameWin.scroll(0, wordTop - 100)
        },
        showSelectedWord (val) {
            if (val.img) { console.log('图片尚不支持定位'); return; }

            var frameDocument = this.getAuditIFrame().document
            $(".log", frameDocument).remove();
            $("span", frameDocument).css("border", "none");
            if (this.activeTabName == "错别字") {
                if (val.wordid.length <= 0) return
                if (val.tipNum < 0 || val.tipNum >= val.wordid.length) { val.tipNum = 0 }
                // 显示tipNum的提示
                $("." + val.wordid[val.tipNum], frameDocument).css({
                    "border-top": "3px solid #00bcd4",
                    "border-bottom": "3px solid #00bcd4",
                    position: "relative",
                });

                $("." + val.wordid[val.tipNum], frameDocument).eq(0).css({ "border-left": "3px solid #00bcd4" });
                $("." + val.wordid[val.tipNum] + ":last", frameDocument).css({ "border-right": "3px solid #00bcd4" });
                // $("." + val.id).wrapAll("<div style='border: 3px solid #f23325;display: inline;padding: 3px 0;'></div>");
                // $("." + val.wordid[val.tipNum]).eq(0).append(
                //     '<div class="log" style="display: block;width: 200px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                //     this.activeTabName + "：" + val.word + "</li></ul></div>"
                // );
                // $(".drop-con").append(
                //     "<li class='text1'>建议修改：" + val.trueword + "</li> "
                // );
                // 跳转到定位位置
                this.gotoWordPos(val.wordid[val.tipNum], 0)
                val.tipNum += 1
                return
            } else if (this.activeTabName == "疑似错别字") {
                if (val.wordid.length <= 0) return
                if (val.tipNum < 0 || val.tipNum >= val.wordid.length) { val.tipNum = 0 }
                // 显示TipNum的提示
                $("." + val.wordid[val.tipNum], frameDocument).css({ "border-top": "3px solid #f23325", "border-bottom": "3px solid #f23325", position: "relative" });
                $("." + val.wordid[val.tipNum], frameDocument).eq(0).css({ "border-left": "3px solid #f23325" })
                $("." + val.wordid[val.tipNum] + ":last", frameDocument).css({ "border-right": "3px solid #f23325" });
                // $("." + val.wordid[val.tipNum]).eq(0)
                // .append(
                //     '<div class="log" style="display: block;width: 200px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                //     this.activeTabName + "：" + val.word + "</li></ul></div>"
                // );
                // if (val.trueword.length > 0) {
                //     $(".drop-con").append(
                //         "<li class='text1'>建议修改：" + val.trueword + "</li> "
                //     );
                // }
                // 跳转到定位位置
                this.gotoWordPos(val.wordid[val.tipNum], 0)
                val.tipNum += 1
                return
            } else {
                console.log(val)
                var nums = $("." + val.id, frameDocument).length - 1;  // 统计当前标记词个数
                this.num += 1
                if (this.num < 0 || this.num > nums) this.num = 0
                // console.log('敏感词、禁用词：', this.num, nums)
                if (nums >= 0) {
                    $("." + val.id, frameDocument).eq(this.num).css({ border: "3px solid #f23325", position: "relative" }).siblings().css("border", "none");

                    // $("." + val.id).eq(this.num).append(
                    //     '<div class="log" style="display: block;width: 200px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                    //     this.activeTabName + "：" + val.word + "</li></ul></div>"
                    // ).siblings().children(".log").remove();
                    // if (this.activeTabName == "敏感词") {
                    //     $(".drop-con").append(
                    //         "<li class='text1'>敏感词类型：" + val.type + "</li> "
                    //     );
                    // }
                    this.gotoWordPos(val.id, this.num)
                }
            }
        },
        cleanAuditTxt (shtml) {
            return this.getCleanTextNew(shtml)
            var curr_txt = shtml
            curr_txt = curr_txt.replace(/<\/(div)>/gi, '<br/>')
                .replace(/<\/h\d>/gi, '<br/>')
                .replace(/<\/(p)>/gi, '<br/>')
                .replace(/<br[^>]*>/gi, '\n')    // 格式化文中的br标签
                .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
                .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
                .replace(/<!--[\s\S]*?-->/gi, '')
                .replace(/<(?!br\b)\/?\w+[^>]*>/gi, '') // 其余标签全删掉

            return curr_txt
        },
        showAuditResult () {
            if (this.stopList.length === 0 && this.suspectList.length === 0 && this.senList.length === 0 && this.typoList.length === 0) {
                // this.$message({ message: '恭喜你，您审核的内容通过无误！', type: 'success' })
                return
            }

            if (this.typoList.length > 0) this.activeTabName = '错别字'
            else if (this.suspectList.length > 0) this.activeTabName = '疑似错别字'
            else if (this.senList.length > 0) this.activeTabName = '敏感词'
            else if (this.stopList.length > 0) this.activeTabName = '禁用词'
            else this.activeTabName = '错别字'

            // 纯文本，用于定位敏感词、禁用词位置，因为没有返回位置
            var auditTxt = this.getCleanAuditTxt()
            // 整理出来展示结果列表
            this.tableDataStop = []
            this.stopList.forEach((item, index) => {
                var obj = {
                    id: 'stop_' + index,
                    word: item.word,
                    number: index + 1,
                    pos: []
                }
                var nStart = 0
                while(true) {
                    var npos = auditTxt.indexOf(obj.word, nStart)
                    if (npos == -1) break
                    obj.pos.push(npos)
                    nStart = npos + obj.word.length
                }
                this.tableDataStop.push(obj)
            })

            this.tableDataSuspect = []
            this.suspectList.forEach((item, index) => {
                var obj = {
                    'number': index + 1,
                    'index': item.index,
                    'word': item.word,
                    'trueword': item.trueword,
                    'tipNum': 0,
                    'pos': [],
                    'wordid': []
                }
                if (obj.trueword == '') obj.trueword = '建议修改为空'
                else if (obj.trueword == undefined) obj.trueword = ''

                var indexArr = obj.index.toString().split(',')
                for (var i = 0; i < indexArr.length; i++) {
                    obj.pos.push(parseInt(indexArr[i]))
                    obj.wordid.push('suspect_' + indexArr[i])
                }
                this.tableDataSuspect.push(obj)
            })

            this.tableDataSen = []
            this.senList.forEach((item, index) => {
                var obj = {
                    'word': item.word,
                    'type': item.type,
                    'id': 'sen_' + index,
                    'number': index + 1,
                    pos: []
                }
                var nStart = 0
                while (true) {
                    var npos = auditTxt.indexOf(obj.word, nStart)
                    if (npos == -1) break;
                    obj.pos.push(npos)
                    nStart = npos + obj.word.length
                }
                this.tableDataSen.push(obj)
            })

            this.tableDataTypo = []
            this.typoList.forEach((item, index) => {
                var typoObj = {
                    'trueword': item.trueword.length === 0 ? '建议修改为空' : item.trueword,
                    'word': item.word,
                    'index': item.index.toString(),
                    'checked': false,
                    'pos': [],
                    'wordid': [],
                    'tipNum': 0,
                    'number': index + 1
                }
                var indexArr = typoObj.index.toString().split(',')
                for (let i = 0; i < indexArr.length; i++) {
                    typoObj.wordid.push('typo_' + indexArr[i])
                    typoObj.pos.push(parseInt(indexArr[i]))
                }
                this.tableDataTypo.push(typoObj)
            })
            this.wordResultList = this.tableDataTypo

            // 从这里开始，将结果标记到内容中 stopList, suspectList, senList, typoList
            // 优先展示typoList，再展示suspectList，最后才是stopList和senList，如果四个结果中存在重复词，按优先级展示
            var signList = []
            this.tableDataTypo.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    signList.push({ word: item.word, type: 'typo', color: 'red', pos: item.pos[i], id: item.wordid[i] })
                }
            })
            this.tableDataSuspect.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    var bExist = false
                    var curr_pos = item.pos[i]
                    for (var j = 0; j < signList.length; j++) {
                        if (curr_pos >= signList[j].pos && curr_pos <= (signList[j].pos + signList[j].word.length - 1)) {
                            bExist = true; break;
                        }
                        if (signList[j].pos >= curr_pos && signList[j].pos <= (curr_pos + item.word.length - 1)) {
                            bExist = true; break;
                        }
                    }
                    if (!bExist) {
                        signList.push({ word: item.word, type: 'suspect', color: '#2196f3', pos: curr_pos, id: item.wordid[i]})
                    }
                }
            })
            this.tableDataStop.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    signList.push({ word: item.word, type: 'stop', color: '#673ab7', pos: item.pos[i], id: item.id })
                }
            })
            this.tableDataSen.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    signList.push({ word: item.word, type: 'sen', color: '#ff9800', pos: item.pos[i], id: item.id })
                }
            })
            
            var needLoading = false
            var auditHtml = this.getIframeAuditHtml()
            if (auditHtml.length > auditTxt.length * 3) needLoading = true
            console.log('html:', auditHtml.length, 'text:', auditTxt.length)

            // 开始逐个词在原文中标记
            var signLoading = null
            if (needLoading)
                signLoading = this.$loading({
                    target: '#audit_txts',
                    lock: true,
                    text: '正在标记结果...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(220, 220, 220, 0.7)'
                })
            setTimeout(async () => {
                const start = performance.now()
                console.log('开始标记')
                const gen = this.signAuditResult(signList)
                while (true) {
                    var genRes = gen.next()
                    console.log(genRes)
                    if (genRes.done) break
                }
                console.log('结束标记', `${(performance.now() - start)/ 1000}s`)
                if (needLoading) signLoading.close()
            }, 1000)
        },
        * signAuditResult (signList) {
            // 对标记列表进行排序
            signList.sort((a, b) => { return a.pos - b.pos })

            var auditHtml = this.getIframeAuditHtml();
            var auditTxt = this.getCleanTextNew(auditHtml)
            var htmlPos = 0, txtPos = 0
            var i = 0
            while (i < signList.length) {
                var item = signList[i]; 
                yield i++
                console.log('sign:', item, htmlPos, txtPos);
                console.log('Text:', auditTxt.substr(item.pos, 10))
                // 有的位置中存在包含关系，当前定位词可能在上一个词前面
                if (item.pos < txtPos) {
                    while(txtPos > item.pos) {
                        htmlPos -= 1
                        var posInfo = this.goPreText(auditHtml, htmlPos, txtPos)
                        if (posInfo === false) break
                        else {
                            htmlPos = posInfo.htmlPos
                            txtPos -= 1
                        }
                    }
                }
                console.log('定位起始位置:', htmlPos, txtPos)

                // 开始标记
                while (true) {
                    var nextInfo = this.goNextText(auditHtml, htmlPos, txtPos)
                    // console.log(nextInfo)
                    if (nextInfo === false) { htmlPos = false; break; }
                    // 到这里是非标签文本
                    htmlPos = nextInfo.htmlPos
                    txtPos = nextInfo.txtPos
                    if (txtPos != item.pos) {
                        if (auditHtml.substr(htmlPos, 6).toLowerCase() == '&nbsp;') {
                            htmlPos += 6
                            txtPos += 1
                        } else {
                            htmlPos += 1
                            txtPos += 1
                        }
                    } else break    // 到这里定位到开始位置
                }
                // console.log('开始位置定位结果：', htmlPos, txtPos)
                if (htmlPos === false || htmlPos === undefined) { console.log('定位失败'); break; }
                // 到这里说明定位到当前结果在HTML中的位置了
                console.log('定位到开始位置:', htmlPos)
                // 找到当前词在HTML中的结束位置
                var htmlEnd = htmlPos
                var txtEnd = txtPos
                for (var j = 1; j < item.word.length; j++) {
                    htmlEnd += 1    // 从下一个位置开始找
                    nextInfo = this.goNextText(auditHtml, htmlEnd, txtEnd)
                    if (nextInfo === false) break
                    htmlEnd = nextInfo.htmlPos
                    txtEnd = nextInfo.txtPos
                    txtEnd += 1 // 找到一个文本字符，值+1
                }
                if (txtEnd - txtPos + 1 != item.word.length || htmlEnd < htmlPos) {
                    console.log('结束位置定位失败')
                    continue
                }
                console.log('定位到结束位置:', htmlEnd, auditHtml.substr(htmlPos, htmlEnd - htmlPos + 1))
                // 到这里，有可能会出现位置偏差，前后相差应该不超过5个字，如果当前定位文本不是目标文本，需要前后重新寻找定位
                if (this.getCleanTextNew(auditHtml.substr(htmlPos, htmlEnd - htmlPos + 1)) !== item.word) {
                    // 先向前寻找
                    var bFind = false
                    var preStartHtml = htmlPos; var preStartTxt = txtPos
                    var preEndHtml = htmlEnd; var preEndTxt = txtEnd
                    for (var j = 0; j < 5; j++) {
                        preStartHtml -= 1
                        var posInfo = this.goPreText(auditHtml, preStartHtml, preStartTxt)
                        if (posInfo === false) { break; } else { preStartHtml = posInfo.htmlPos; preStartTxt -= 1 }
                        // console.log('startPos:', posInfo)
                        preEndHtml -= 1
                        posInfo = this.goPreText(auditHtml, preEndHtml, preEndTxt)
                        if (posInfo === false) { break; } else { preEndHtml = posInfo.htmlPos; preEndTxt -= 1 }
                        // console.log('endPos:', posInfo)
                        // console.log('向前定位：', j + 1, preStartHtml, preEndHtml)
                        var tmpHtml = auditHtml.substr(preStartHtml, preEndHtml - preStartHtml + 1)
                        // console.log(tmpHtml)
                        if (this.getCleanTextNew(tmpHtml) == item.word) {
                            bFind = true
                            htmlPos = preStartHtml; txtPos = preStartTxt
                            htmlEnd = preEndHtml; txtEnd = preEndTxt
                            break
                        }
                    }
                    if (!bFind) {
                        var nextStartHtml = htmlPos; var nextStartTxt = txtPos
                        var nextEndHtml = htmlEnd; var nextEndTxt = txtEnd
                        for (var j = 0; j < 5; j++) {
                            nextStartHtml += 1
                            var posInfo = this.goNextText(auditHtml, nextStartHtml, nextStartTxt)
                            if (posInfo === false) { break; } else { nextStartHtml = posInfo.htmlPos; nextStartTxt += 1 }
                            // console.log('start:', posInfo)
                            nextEndHtml += 1
                            posInfo = this.goNextText(auditHtml, nextEndHtml, nextEndTxt)
                            if (posInfo === false) { break; } else { nextEndHtml = posInfo.htmlPos; nextEndTxt += 1 }
                            // console.log('end:', posInfo)
                            // console.log('向后定位：', j + 1, nextStartHtml, nextEndHtml)
                            var tmpHtml = auditHtml.substr(nextStartHtml, nextEndHtml - nextStartHtml + 1)
                            // console.log('网页段：', tmpHtml)
                            if (this.getCleanTextNew(tmpHtml) == item.word) {
                                bFind = true
                                htmlPos = nextStartHtml; txtPos = nextStartTxt
                                htmlEnd = nextEndHtml; txtEnd = nextEndTxt
                                break
                            }
                        }
                    }
                }
                // 开始标记 signList.push({ word: item.word, type: 'typo', color: 'red', pos: item.pos[i], id: item.wordid[i] })
                var tmpHtml = auditHtml.substr(0, htmlPos)
                tmpHtml += ("<span class='" + item.id + "' style='background:" + item.color + ";color:white;text-indent: 0pt;'>")
                var newHtmlPos = tmpHtml.length
                tmpHtml += auditHtml.substr(htmlPos, htmlEnd - htmlPos + 1)
                tmpHtml += "</span>"
                tmpHtml += auditHtml.substr(htmlEnd+1)
                auditHtml = tmpHtml
                htmlPos = newHtmlPos
                console.log(' ')
            }
            // 更新标记结果
            this.setIframeAuditHtml(auditHtml);
            return i
        },
        goNextText(docHtml, htmlPos, txtPos) {
            // console.log('start:', htmlPos, txtPos)
            var htmlLen = docHtml.length
            while (htmlPos < htmlLen && docHtml[htmlPos] === '<') {
                var tagEnd = -1
                if(docHtml.substr(htmlPos, 7).toLowerCase() === '<script') {
                    var pos = docHtml.toLowerCase().indexOf('/script>', htmlPos);
                    if(pos != false) tagEnd = pos + 7;
                }
                else if (docHtml.substr(htmlPos, 6).toLowerCase() === '<style') {
                    var pos = docHtml.toLowerCase().indexOf('/style>', htmlPos);
                    if (pos != false) { tagEnd = pos + 6; }
                }
                else if (docHtml.substr(htmlPos, 4) === '<!--') {
                    var pos = docHtml.indexOf('-->', htmlPos);
                    if (pos != false) tagEnd = pos + 2;
                }
                else if (docHtml.substr(htmlPos, 5).toLowerCase() === '<!doc') {
                    var pos = docHtml.indexOf('>', htmlPos);
                    if (pos != false) tagEnd = pos;
                }
                else if(docHtml[htmlPos + 1].toLowerCase() >= 'a' && docHtml[htmlPos + 1].toLowerCase() <= 'z') {
                    var pos = docHtml.indexOf('>', htmlPos);
                    if (pos != false) tagEnd = pos;
                }
                else if(docHtml[htmlPos + 1] === '/' && docHtml[htmlPos + 2].toLowerCase() >= 'a' && docHtml[htmlPos + 2].toLowerCase() <= 'z') {
                    var pos = docHtml.indexOf('>', htmlPos);
                    if (pos != false) tagEnd = pos;
                }
                if(tagEnd === -1) break
                // console.log('skip:', docHtml.substr(htmlPos, tagEnd - htmlPos + 1))
                // if (docHtml.substr(htmlPos, 4).toLowerCase() === '</p>') txtPos += 1
                // else if (docHtml.substr(htmlPos, 6).toLowerCase() === '</div>') txtPos += 1
                // else if (docHtml.substr(htmlPos, 3).toLowerCase() === '<br') txtPos += 1
                // else if (docHtml.substr(htmlPos, 3).toLowerCase() === '</h' && docHtml[htmlPos+3] >= '1' && docHtml[htmlPos+3] <= '9') txtPos += 1
                htmlPos = tagEnd + 1
            }
            if (htmlPos >= htmlLen) return false
            // 到这里说明定位到下一个文本位置了
            // console.log('定位文本：', htmlPos, txtPos)
            return { htmlPos, txtPos }
        },
        goPreText (docHtml, htmlPos, txtPos) {
            // console.log('start:', htmlPos, txtPos)
            var htmlLen = docHtml.length
            while (htmlPos >= 0 && docHtml[htmlPos] === '>') {
                var tagStart = -1
                if(htmlPos >= 6 && docHtml.substr(htmlPos - 6, 7).toLowerCase() === 'script>') {
                    var pos = docHtml.toLowerCase().lastIndexOf('<script', htmlPos)
                    if(pos != false) tagStart = pos;
                }
                else if (htmlPos >= 5 && docHtml.substr(htmlPos - 5, 6).toLowerCase() === 'style>') {
                    var pos = docHtml.toLowerCase().lastIndexOf('<style', htmlPos);
                    if (pos != false) { tagStart = pos; }
                }
                else if (htmlPos >= 2 && docHtml.substr(htmlPos - 2, 3) === '-->') {
                    var pos = docHtml.lastIndexOf('<!--', htmlPos);
                    if (pos != false) tagStart = pos;
                }
                else {
                    var pos = docHtml.lastIndexOf('<', htmlPos)
                    if (pos !== false) {
                        if (docHtml.substr(pos, 5).toLowerCase() === '<!doc') tagStart = pos
                        else if (docHtml[pos + 1].toLowerCase() >= 'a' && docHtml[pos + 1].toLowerCase() <= 'z') {
                            tagStart = pos
                        }
                        else if (docHtml[pos + 1] === '/' && docHtml[pos + 2].toLowerCase() >= 'a' && docHtml[pos + 2].toLowerCase() <= 'z') {
                            tagStart = pos
                        }
                    }
                }
                if(tagStart === -1) break
                htmlPos = tagStart - 1
            }
            if (htmlPos < 0) return false
            // 到这里说明定位到下一个文本位置了
            // console.log('定位文本：', htmlPos, txtPos)
            return { htmlPos, txtPos }
        },
        getCleanTextNew (html) {
            // console.log('获取纯文本：', html)
            var cleanText = ''
            var htmlPos = 0; var txtPos = 0;
            while (true) {
                var nextInfo = this.goNextText(html, htmlPos, txtPos)
                if (nextInfo == false) break
                // 获取与上次定位位置之间的源码内容，判断是否有需要换行的
                // var tmpHtml = html.substr(htmlPos, nextInfo.htmlPos - htmlPos).toLowerCase()
                // if (tmpHtml.indexOf("</div>") != -1 || tmpHtml.indexOf('</p>') != -1)
                htmlPos = nextInfo.htmlPos; txtPos = nextInfo.txtPos
                cleanText += html[htmlPos]; htmlPos += 1
            }
            // console.log('纯文本：', cleanText)
            return cleanText
        },
        hideTips () {
            var frameDocument = this.getAuditIFrame().document
            $(".log", frameDocument).remove();
            $("span", frameDocument).css("border", "none");
        },
        // 错别字结果选中
        checkAllResult () {
            if (this.isCheckAllResult === true) {
                this.wordResultList.forEach((item) => {
                    $('.icon' + item.number).show()
                    item.checked = true
                })
            } else {
                this.wordResultList.forEach((item) => {
                    $('.icon' + item.number).hide()
                    item.checked = false
                })
            }
        },
        checkItemResult (val) {
            if (val.checked == true) {
                $(".icon" + val.number).show()
            } else {
                $(".icon" + val.number).hide()
                this.isCheckAllResult = false
            }
        },
        // 审核页面中需要用到的修改、撤回功能
        btnXiuGai () {
            var frameDocument = this.getAuditIFrame().document
            // 修改前，先去掉所有点击提示，避免修改后撤回导致的样式混乱
            this.hideTips()

            var changeNum = 0
            var preChangeText = this.getIframeAuditHtml()
            for (var i = 0; i < this.wordResultList.length; i++) {
                if (this.wordResultList[i].checked === false) continue
                for (var j = 0; j < this.wordResultList[i].wordid.length; j++) {
                    changeNum += 1
                    // $('.' + this.wordResultList[i].wordid[j]).wrapAll("<div id=" + this.wordResultList[i].wordid[j] + " style='display: inline;'></div>")
                    $("." + this.wordResultList[i].wordid[j], frameDocument).replaceWith(this.wordResultList[i].trueword);
                }
            }
            if (changeNum === 0) {
                this.$message({ message: '请勾选修改项', type: 'warning' })
            } else {
                console.log('修改了' + changeNum + '处')
                this.contentList.push(preChangeText)
            }
        },
        btnCheHui () {
            if (this.contentList.length > 1) {
                this.setIframeAuditHtml(this.contentList.pop())
            } else {
                //
            }
        },
        exportCommand (command) {
            console.log('导出：', command)
            var shtml = this.getIframeAuditHtml()
            // 生成 appsecret
            let date = new Date()
            let year = date.getFullYear()
            let month = ('0' + (date.getMonth() + 1)).slice(-2)
            let day = ('0' + date.getDate()).slice(-2)
            var appsecret = this.$md5(sessionStorage.getItem('appkey') + (year + month + day))
            this.exportResultLoading = true
            this.$axios.post('/cmsMateService/servlet/' + (command == 'html' ? 'Html2Html' : 'Html2Word'), {
                content: shtml,
                appkey: sessionStorage.getItem('appkey'),
                appsecret: appsecret
            }).then(res => {
                this.exportResultLoading = false
                if (res.status != 200 || res.data.code != '200') {
                    this.$message({ message: '导出失败', type: 'warning' })
                    return
                }
                var fileLink = res.data.info
                console.log('导出文件地址：', fileLink)
                const link = document.createElement('a');
                link.href = fileLink
                link.target = '_blank'
                link.setAttribute('download', '')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }).catch(error => {
                this.exportResultLoading = false
                console.log(error)
                this.$message({ message: '导出异常', type: 'warning' })
            })
        },
        exportWord() {
            if (this.auditContentLen === 0) {
                this.$message({ message: '审核文本为空', type: 'warning' })
                return
            }
            if (this.typoList.length === 0 && this.suspectList.length === 0 && this.stopList.length === 0 && this.senList.length === 0) {
                this.$message({ message: '没有审核结果或者文本没有错误', type: 'warning' })
                return
            }
            // 处理换行
            var sText = this.getCleanAuditTxt()// this.contentList[0]
            sText = sText.replace(/<br[^>]*>/gi, '\n')
            let _this = this;
            // 读取并获得模板文件的二进制内容/web
            JSZipUtils.getBinaryContent("/static/file/index.docx", function (error, content) {
                // input.docx是模板。我们在导出的时候，会根据此模板来导出对应的数据
                // 抛出异常
                if (error) { throw error; }
                // 创建一个PizZip实例，内容为模板的内容
                let zip = new PizZip(content);
                // 创建并加载docxtemplater实例对象
                let doc = new docxtemplater(zip, {linebreaks: true});//.loadZip(zip);

                var tab1 = [];
                var tab2 = [];
                var tab3 = [];
                var tab4 = [];
                if (_this.tableDataTypo.length != 0) { tab1.push(1); }
                if (_this.tableDataSen.length != 0) { tab2.push(1); }
                if (_this.tableDataStop.length != 0) { tab3.push(1); }
                if (_this.tableDataSuspect.length != 0) { tab4.push(1); }
                console.log(tab1, tab2, tab3, tab4);
                // 设置模板变量的值
                doc.setData({
                    content: sText,
                    table: _this.tableDataTypo,
                    table2: _this.tableDataSen,
                    table3: _this.tableDataStop,
                    table4: _this.tableDataSuspect,
                    tab1: tab1,
                    tab2: tab2,
                    tab3: tab3,
                    tab4: tab4,
                })

                try {
                    // 用模板变量的值替换所有模板变量
                    doc.render();
                } catch (error) {
                    // 抛出异常
                    let e = {
                        message: error.message,
                        name: error.name,
                        stack: error.stack,
                        properties: error.properties,
                    }
                    console.log(JSON.stringify({ error: e }))
                    throw error;
                }

                // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
                let out = doc.getZip().generate({
                    type: "blob",
                    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                })
                // 将目标文件对象保存为目标类型的文件，并命名
                saveAs(out, "检测文档.docx")
            });
        },
        checkAuditHtml () {
            var auditHtml = this.getIframeAuditHtml()
            console.log('check:', auditHtml)

            auditHtml = auditHtml.replace(/<!--[\s\S]*?-->/gi, '')
            auditHtml = auditHtml.replace(/&nbsp;/gi, ' ').replace(/\n/gi, '')
            auditHtml = auditHtml.replace(/<\/p>/gi, '</p>\n').replace(/<\/div>/gi, '</div>\n')
            auditHtml = auditHtml.replace(/<br[^>]*>/gi, '<br/>').replace(/<br\/>/gi, '<br/>\n')
            auditHtml = auditHtml.replace(/(<\/h\d+>)/gi, '$1\n')
            auditHtml = auditHtml.replace(/([^\n])<p /gi, '$1\n<p ').replace(/([^\n])<div /gi, '$1\n<div ')
            auditHtml = auditHtml.replace(/([^\n])<p>/gi, '$1\n<p>').replace(/([^\n])<div>/gi, '$1\n<div>')

            console.log('result:', auditHtml)
            this.setIframeAuditHtml(auditHtml)
            this.auditContentLen = this.cleanAuditTxt(auditHtml).replace(/\n|\r/gi, "").length
        },
        getContentWinHeight () {
            return window.top.document.getElementById('audit_txts').clientHeight
        }
    },
    mounted () {
        this.activeTabName = '错别字'

        // 让iframe可编辑
        // var frameWin = this.getAuditIFrame()
        // frameWin.document.designMode = 'on'
        // frameWin.document.contentEditable = true
        // // 兼容 FireFox, 打开并写入
        // frameWin.document.open();
        // frameWin.document.writeln('<html><head>');
        // // frameWin.document.writeln('<style>body {background: white;font-size:9pt;margin: 2px; padding: 0px;}</style>');
        // frameWin.document.writeln('</head><body></body></html>');
        // frameWin.document.close();

        // this.getAuditIFrame().document.addEventListener('click', () => {
        //     console.log('iframe点击')
        //     this.hideTips()

        //     var cleanTxt = this.getCleanAuditTxt()
        //     console.log(cleanTxt)
        //     console.log(cleanTxt.replace(/\n|\r/gi, "").length)
        // })
        // this.getAuditIFrame().document.addEventListener('keyup', () => {
        //     console.log('keyup事件')
        //     var auditHtml = this.getIframeAuditHtml()
        //     this.auditContentLen = this.cleanAuditTxt(auditHtml).replace(/\n|\r/gi, "").length
        // })
        // this.getAuditIFrame().document.addEventListener('paste', (e) => {
        //     console.log('粘贴事件：', e.clipboardData)
        //     setTimeout(() => {
        //         this.checkAuditHtml()
        //     }, 500);
        // })
        this.editHeight = 560
        this.editHeight = window.top.document.getElementById('audit_txts').clientHeight
        window.addEventListener('resize', () => {
            console.log('内容窗口高度：', window.top.document.getElementById('audit_txts').clientHeight)
            this.editHeight = window.top.document.getElementById('audit_txts').clientHeight
        })
    }
}
</script>

<style lang="less">
body{
    font-size: 11px;
}
#audit_txts:empty:before {
    content: "请输入检测内容...";
    color: gray;
}
#audit_txts:focus:before {
    content: none;
}
#audit_txts {
    width: 70%;
    // height: 100%;
    // min-height: 100px;
    // overflow-y: scroll;
    letter-spacing: 1px;
    border: 1px solid #ddd !important;
    outline: none;
    text-align: left;
    font-size: 16px;
}

.right-box {
    width: 42%;
    position: relative;
    // height: 100%;
    padding: 3px 14px;
    overflow-y: scroll;
    border: 1px solid #ddd;
}
.right-box:empty:before {
    content: attr(placeholder);
    color: #bbb;
}
.right-box:focus:before {
    content: none;
}

.audit-result-table table {
    border-collapse: collapse;
    table-layout: fixed;
    border-radius: 5px;
    overflow: hidden;
    margin: 10px auto;
    /* // height: 250px; */
    font-family: emoji;
    font-size: 15px;
    /* // border: 2px solid #70aefb; */
    color: #f4f5f7;
    background-color: #328ef4;
}
.audit-result-table table td,
.audit-result-table th {
    padding: 3px;
    text-align: center;
    border: 1px solid #f5f7fa75;
    vertical-align: middle;
    font-size: 15px;
    padding: 5px;
    width: 80%;
}
.audit-result-table tbody {
    background-color: #328ef4;
}
.icons {
    font-size: 15px;
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    width: 91px;
    float: right;
    color: #2196f3;
    margin-right: 5px;
    margin-top: -35px;
}
.tts {
    width: 25px;
    height: 25px;
}
/deep/.tts .el-checkbox__inner {
    background-color: rgb(107, 107, 107);
}
</style>



// WEBPACK FOOTER //
// src/components/DocAudit.vue